// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import CheckboxController from "./checkbox_controller"
application.register("checkbox", CheckboxController)

import CopyExampleSentenceController from "./copy_example_sentence_controller"
application.register("copy-example-sentence", CopyExampleSentenceController)

import CreateInvoicesController from "./create_invoices_controller"
application.register("create-invoices", CreateInvoicesController)

import CreateOutsourcedOrderController from "./create_outsourced_order_controller"
application.register("create-outsourced-order", CreateOutsourcedOrderController)

import DhtmlxSchedulerController from "./dhtmlx_scheduler_controller"
application.register("dhtmlx-scheduler", DhtmlxSchedulerController)

import DisableBlankPasswordController from "./disable_blank_password_controller"
application.register("disable-blank-password", DisableBlankPasswordController)

import DiscountSalesController from "./discount_sales_controller"
application.register("discount-sales", DiscountSalesController)

import FetchBranchController from "./fetch_branch_controller"
application.register("fetch-branch", FetchBranchController)

import FilterSelectController from "./filter_select_controller"
application.register("filter-select", FilterSelectController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import InitializeBeforeSubmitController from "./initialize_before_submit_controller"
application.register("initialize-before-submit", InitializeBeforeSubmitController)

import ManualOrderRegisterController from "./manual_order_register_controller"
application.register("manual-order-register", ManualOrderRegisterController)

import MoveElementWithEnterController from "./move_element_with_enter_controller"
application.register("move-element-with-enter", MoveElementWithEnterController)

import OrderFormController from "./order_form_controller"
application.register("order-form", OrderFormController)

import OrderTableController from "./order_table_controller"
application.register("order-table", OrderTableController)

import PaymentCheckController from "./payment_check_controller"
application.register("payment-check", PaymentCheckController)

import PaymentsController from "./payments_controller"
application.register("payments", PaymentsController)

import PreventEnterSubmitController from "./prevent_enter_submit_controller"
application.register("prevent-enter-submit", PreventEnterSubmitController)

import PriceTableController from "./price_table_controller"
application.register("price-table", PriceTableController)

import PrintTemporarySlipsController from "./print_temporary_slips_controller"
application.register("print-temporary-slips", PrintTemporarySlipsController)

import PutCrossController from "./put_cross_controller"
application.register("put-cross", PutCrossController)

import QuoteItemController from "./quote_item_controller"
application.register("quote-item", QuoteItemController)

import QuoteItemsController from "./quote_items_controller"
application.register("quote-items", QuoteItemsController)

import QuoteStatusUpdateController from "./quote_status_update_controller"
application.register("quote-status-update", QuoteStatusUpdateController)

import SalesTargetController from "./sales_target_controller"
application.register("sales-target", SalesTargetController)

import ShowDisabledBalancesController from "./show_disabled_balances_controller"
application.register("show-disabled-balances", ShowDisabledBalancesController)

import TentativeCalculateController from "./tentative_calculate_controller"
application.register("tentative-calculate", TentativeCalculateController)

import TkTimePickerController from "./tk_time_picker_controller"
application.register("tk-time-picker", TkTimePickerController)

import ToggleSchedulerPopupController from "./toggle_scheduler_popup_controller"
application.register("toggle-scheduler-popup", ToggleSchedulerPopupController)

import ToggleSubmenuController from "./toggle_submenu_controller"
application.register("toggle-submenu", ToggleSubmenuController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import UpdateClientTDmController from "./update_client_t_dm_controller"
application.register("update-client-t-dm", UpdateClientTDmController)

import UpdateDeliveryGroupIdController from "./update_delivery_group_id_controller"
application.register("update-delivery-group-id", UpdateDeliveryGroupIdController)

import UpdateDeliveryGroupRepresentativeController from "./update_delivery_group_representative_controller"
application.register("update-delivery-group-representative", UpdateDeliveryGroupRepresentativeController)

import UpdateDiePriceController from "./update_die_price_controller"
application.register("update-die-price", UpdateDiePriceController)

import WorkStatusController from "./work_status_controller"
application.register("work-status", WorkStatusController)
